import React from 'react';

import {TBadgeColor, TBadgeSize} from './constants';
import * as S from './style';

type TProps = {
  children: React.ReactNode;
  color?: TBadgeColor;
  className?: string;
  isSolid?: boolean;
  isSquare?: boolean;
  fontWeight?: number;
  size?: TBadgeSize;
};

const Badge = React.memo<TProps>(
  ({children, color = 'BLUE', className, isSolid, isSquare, fontWeight, size}) => (
    <S.Badge
      className={className}
      color={color}
      isSolid={isSolid}
      isSquare={isSquare}
      fontWeight={fontWeight}
      size={size}
    >
      {children}
    </S.Badge>
  ),
);

export default Badge;

export type {TBadgeColor};
